/*
  French override for the login error message rendered by the
  cctn-draft-order app's account-auth block.

  The app's built-in French copy shows the English fallback
  'Invalid email or password.' on some flows. We can't edit the app
  from the theme, so we DOM-watch the app's error banner element
  (`.storefront-auth__banner`) and swap its text when we detect the
  known English error string on an FR locale page.

  Guarded on window.__CCTN_LOCALE (set in layout/theme.liquid). No-op
  on non-FR locales.
*/
(function () {
  var locale = (window.__CCTN_LOCALE || document.documentElement.lang || '').toString().toLowerCase();
  if (locale.indexOf('fr') !== 0) return;

  var REPLACEMENTS = {
    'Invalid email or password.': 'Courriel ou mot de passe invalide.',
    'Invalid email or password':  'Courriel ou mot de passe invalide.'
  };

  function fix(el) {
    if (!el) return;
    var t = (el.textContent || '').trim();
    if (REPLACEMENTS[t]) el.textContent = REPLACEMENTS[t];
  }

  function scan() {
    document.querySelectorAll('.storefront-auth__banner').forEach(fix);
  }

  var observer = new MutationObserver(function () { scan(); });
  observer.observe(document.body, { childList: true, subtree: true, characterData: true });

  var pollId = setInterval(scan, 500);
  window.addEventListener('beforeunload', function () { clearInterval(pollId); observer.disconnect(); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
})();
